import { ActionIcon, Box, Flex } from '@mantine/core';
import React, { useEffect, useRef, useState } from 'react'
import ExportExcel from '../../ExportExcel';
import { BsPrinter } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';
import { useMediaQuery } from 'react-responsive';

function TabAbsenKeluar({
    karyawanid,
    absensiKeluar,
    formattedTotalEarlyDuration,
    formattedTotalOverDuration
}) {

    const isMobile = useMediaQuery({ maxWidth: 767 });

    const navigate = useNavigate();

    const printAbsensi = () => {
        navigate("/absen-keluar/" + karyawanid);
    }

    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (absensiKeluar && absensiKeluar.length > 0) {
            const dataTableFilter = absensiKeluar.map(({ ...rest }) => rest);

            setRowData(
                dataTableFilter.map((data) => {
                    const dateParts = data?.checkout_time.split('T')[0].split('-');
                    const year = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const day = Number(dateParts[2]);

                    return {
                        ...data,
                        date: new Date(year, month, day),
                    };
                })
            );
        }
    }, [absensiKeluar]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const cellDate = new Date(cellValue.getFullYear(), cellValue.getMonth(), cellValue.getDate());

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };

    const colDefs = [
        // {
        //     field: "detail",
        //     headerName: 'Detail',
        //     width: 120,
        //     pinned: 'left',
        //     cellRenderer: (row) => {
        //         return (
        //             <div
        //                 style={{
        //                     width: "100%",
        //                     height: "100%",
        //                     display: "flex",
        //                     alignItems: "center",
        //                     justifyContent: "center",
        //                     cursor: "pointer",
        //                 }}
        //                 onClick={() => handleAbsensiDetailTabKeluar(row?.data)}
        //             >
        //                 <GoInfo
        //                     size={20}
        //                     style={{ cursor: 'pointer' }}
        //                 />
        //             </div>
        //         );
        //     },
        // },
        {
            field: "date",
            headerName: "Tanggal",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const date = params.value;
                if (date instanceof Date && !isNaN(date)) {
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "jam",
            headerName: 'Jam',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.checkout_time.split('T')[1].split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "early_duration",
            headerName: 'Pulang Awal',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.early_duration?.split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "overtime_duration",
            headerName: 'Lembur',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.overtime_duration?.split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "checkout_place",
            headerName: 'Lokasi',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.checkout_place}
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const gridRef = useRef(null);

    const handleExportRowsExcelData = () => {
        if (!gridRef.current) return [];

        const filteredRows = [];
        gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            if (node.data) {
                filteredRows.push(node.data);
            }
        });

        const excelData = filteredRows.map((row) => ({
            'Absen Pulang': row.checkout_time,
            'Pulang Awal': row.early_duration,
            'Lembur': row.overtime_duration,
            'Total Pulang Awal Bulan Ini': formattedTotalEarlyDuration,
            'Total Lembur Bulan Ini': formattedTotalOverDuration,
        }));

        return excelData;
    };



    return (
        <Box>
            {/* Top Toolbar */}
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                }}
            >
                <Flex gap="xs" align="center">
                    <ActionIcon onClick={printAbsensi}>
                        <BsPrinter style={{ backgroundColor: 'transparent', color: '#222' }} size={40} />
                    </ActionIcon>
                    <ActionIcon>
                        <ExportExcel
                            getExcelData={handleExportRowsExcelData}
                            fileName="Data Absensi Pulang"
                        />
                    </ActionIcon>
                </Flex>
            </Box>
            <div style={{ height: 500 }}>

                <AgGridReact
                    theme={themeLightCold}
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    pagination={isMobile ? false : true}
                    rowHeight={25}
                />

            </div>
        </Box>
    )
}

export default TabAbsenKeluar
